import {authorNodeTrait} from './authorNodeTrait'
import {imageNodeTrait} from './imageNodeTrait'
import {imageCropTrait} from './imageCropTrait'

/**
 * @description
 * Contains a bundle of common traits usable in plugin development
 * ### Usage
 * Import `traitBundle` from package `writer` and fetch the traits you wish to implement.
 *
 * @example
 * import {withTraits, traitBundle} from 'writer'
 * const {imageNodeTrait, imageCropTrait} = traitBundle
 *
 * @memberof Trait
 * @typedef Trait.traitBundle
 *
 * @property {Trait.authorNodeTrait} authorNodeTrait
 * @property {Trait.imageCropTrait} imageCropTrait
 * @property {Trait.imageNodeTrait} imageNodeTrait
 */
const traitBundle = {
    /**
     * @param api
     * @returns {{authorNodeTrait: {_isEqual, addAuthor, setAuthors, removeAuthor, fetchAuthorConcept, findAttribute, fetchAuthorsConcept, updateAuthorFromConcept}, imageCropTrait: {setSoftcropData}, imageNodeTrait: {fetchSpecifiedUrls: (function(Array.<string>): Promise), getImageFile: (function()), getUrl: (function())}}}
     * @private
     */
    build(api) {
        return {
            authorNodeTrait: authorNodeTrait(api),
            imageCropTrait: imageCropTrait(api),
            imageNodeTrait: imageNodeTrait(api)
        }
    }
}

export {traitBundle}
